import { Observable } from "../../events";
export class PointerToDragController {
    constructor(source) {
        this._pointerState = new Map();
        this._observers = [];
        this._onStart = (e) => {
            if (e.pointerType === "touch") {
                return;
            }
            const x = this._getClientX(e);
            const y = this._getClientY(e);
            var state = {
                startX: x,
                startY: y,
                lastX: x,
                lastY: y,
                button: e.button,
            };
            this._pointerState.set(e.pointerId, state);
            const event = {
                type: "start",
                pointerId: e.pointerId,
                button: state.button,
                startX: state.startX,
                startY: state.startY,
                x: x,
                y: y,
                deltaX: 0,
                deltaY: 0,
                timestamp: performance.now(),
                originalEvent: e,
            };
            this.onDragObservable.notifyObservers(event);
        };
        this._onMove = (e) => {
            if (e.pointerType === "touch") {
                return;
            }
            const state = this._pointerState.get(e.pointerId);
            if (state) {
                const x = this._getClientX(e);
                const y = this._getClientY(e);
                const dx = x - state.lastX;
                const dy = y - state.lastY;
                const event = {
                    type: "drag",
                    pointerId: e.pointerId,
                    button: state.button,
                    startX: state.startX,
                    startY: state.startY,
                    x: x,
                    y: y,
                    deltaX: dx,
                    deltaY: dy,
                    timestamp: performance.now(),
                    originalEvent: e,
                };
                this.onDragObservable.notifyObservers(event);
                state.lastX = x;
                state.lastY = y;
            }
        };
        this._onEnd = (e) => {
            if (e.pointerType === "touch") {
                return;
            }
            const state = this._pointerState.get(e.pointerId);
            if (state) {
                const x = this._getClientX(e);
                const y = this._getClientY(e);
                const dx = x - state.startX;
                const dy = y - state.startY;
                this.onDragObservable.notifyObservers({
                    type: "end",
                    pointerId: e.pointerId,
                    button: state.button,
                    startX: state.startX,
                    startY: state.startY,
                    x: x,
                    y: y,
                    deltaX: dx,
                    deltaY: dy,
                    timestamp: performance.now(),
                    originalEvent: e,
                });
                this._pointerState.delete(e.pointerId);
            }
        };
        this._source = source;
    }
    dispose() {
        this._detachSource();
        this._clearObservable();
        this._pointerState.clear();
    }
    get onDragObservable() {
        if (!this._onDragObservable) {
            this._onDragObservable = new Observable();
            this._attachSource(this._source);
        }
        return this._onDragObservable;
    }
    get source() {
        return this._source;
    }
    _clearObservable() {
        this._onDragObservable?.clear();
    }
    _attachSource(source) {
        if (source && this._onDragObservable) {
            this._observers.push(source.onPointerDownObservable.add(this._onStart), source.onPointerMoveObservable.add(this._onMove), source.onPointerUpObservable.add(this._onEnd), source.onPointerCancelObservable.add(this._onEnd));
        }
    }
    _detachSource() {
        for (const observer of this._observers) {
            if (observer) {
                observer.disconnect();
            }
        }
        this._observers = [];
    }
    _getClientX(e) {
        return e.clientX;
    }
    _getClientY(e) {
        return e.clientY;
    }
}
//# sourceMappingURL=map.inputs.controller.drag.js.map